module.exports = __webpack_public_path__ + "img/ardown.74fa35ab.png";